package com.cybergstudios.rtc.engine

import com.cybergstudios.rtc.ai.AgentOpponent
import com.cybergstudios.rtc.levels.Level01
import com.cybergstudios.rtc.world.Ball
import com.cybergstudios.rtc.world.Paddle
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.TouchEvent
import org.w3c.dom.asList
import org.w3c.dom.events.KeyboardEvent

/**
 * The engine builder is responsible for creating a platform specific context and
 * then instantiating the engine. The engine is platform-agnostic.
 */
object EngineBuilder {

    /**
     * We only target the browser context but different platforms could be implemented introducing a platform
     * implementation of the interface `Context`.
     */
    fun build(): Engine = buildHtml()

    private fun buildHtml(): Engine {
        val canvas = document.getElementById("rtc") as HTMLCanvasElement
        val ctx = canvas.getContext("2d") as CanvasRenderingContext2D

        val canvasDimension = CanvasDimension(
            originX = ctx.canvas.width / 2.0,
            originY = ctx.canvas.height / 2.0,
            borderMaxX = ctx.canvas.width / 2.0,
            borderMinX = ctx.canvas.width / 2.0 * -1.0,
            borderTop = ctx.canvas.height / 2.0,
            borderBottom = ctx.canvas.height / 2.0 * -1.0,
        )

        val context = ContextWeb(ctx)

        val state = GameState(
            context,
            canvasDimension,
            GameStateMode.PLAYING,
            3,
            0,
            3,
            Level01,
            Paddle.newPaddlePlayer(),
            Paddle.newPaddleOpponent(),
            AgentOpponent(),
            Ball(),
            window.performance.now(),
        )

        val engine = Engine(state)

        // keyboard listener
        window.document.addEventListener("keydown", {
            val event = it as KeyboardEvent
            when (event.key) {
                "ArrowRight" -> engine.moveRight()
                "ArrowLeft" -> engine.moveLeft()
                else -> {}
            }
        })

        // phone & ipad listener
        window.document.addEventListener("touchstart", {
            val event = it as TouchEvent
            event.preventDefault()
            event.changedTouches.asList().forEach { touch ->
                if (touch.pageX <= state.canvasDimension.originX) {
                    state.paddlePlayer.moveLeft()
                } else {
                    state.paddlePlayer.moveRight()
                }
            }
        }, false)

        return engine
    }
}
